// BEST PRACTICES:
// - No LanguageContext (Polish-only landing page)
// - Explicit colors (no CSS variables)
// - Simple, static content

const Footer = () => {
  return (
    <footer className="relative bg-gray-900 text-white py-14 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          {/* Logo and description */}
          <div className="col-span-2 space-y-4">
            <span className="font-bold text-xl tracking-tight">Viraluj.pl</span>
            <p className="text-gray-400 text-sm max-w-sm leading-relaxed">
              Viraluj.pl to platforma, która pomoże Ci tworzyć content, który rzeczywiście działa i generuje zasięgi.
            </p>
            <p className="text-gray-500 text-xs max-w-sm leading-relaxed">
              Stworzone w Polsce dla twórców, marek i agencji.
            </p>
          </div>

          {/* Product — wraps all landing sections in a 2-column list */}
          <div className="col-span-2 md:col-span-3">
            <h3 className="font-medium mb-4 text-white">Produkt</h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-gray-400 text-sm">
              <li><a href="/#features" className="hover:text-white transition-colors">Jak to działa</a></li>
              <li><a href="/#trzy-kroki" className="hover:text-white transition-colors">Trzy kroki</a></li>
              <li><a href="/#demo" className="hover:text-white transition-colors">Zobacz demo</a></li>
              <li><a href="/#warsztat" className="hover:text-white transition-colors">Warsztat</a></li>
              <li><a href="/#panel-klienta" className="hover:text-white transition-colors">Panel klienta</a></li>
              <li><a href="/#porownanie" className="hover:text-white transition-colors">Porównaj wyniki</a></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">Cennik</a></li>
              <li><a href="/auth?mode=register&trial=true" className="hover:text-white transition-colors">Wypróbuj za darmo</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-medium mb-4 text-white">Wsparcie</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/kontakt" className="hover:text-white transition-colors">Kontakt</a></li>
              <li><a href="/pomoc" className="hover:text-white transition-colors">Centrum pomocy</a></li>
              <li><a href="/faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/blog" className="hover:text-white transition-colors">Blog</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2025 Viraluj.pl. Wszystkie prawa zastrzeżone.</p>
          <div className="flex gap-6 text-sm">
            <a href="/polityka-prywatnosci" className="text-gray-500 hover:text-white transition-colors">Polityka prywatności</a>
            <a href="/regulamin" className="text-gray-500 hover:text-white transition-colors">Regulamin</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
